import { render, staticRenderFns } from "./baseSelect.vue?vue&type=template&id=2e7da2c5&"
import script from "./baseSelect.vue?vue&type=script&lang=js&"
export * from "./baseSelect.vue?vue&type=script&lang=js&"
import style0 from "./baseSelect.vue?vue&type=style&index=0&id=2e7da2c5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports